const Menu = [
  {
    image: "images/NextStep/MainPage.webp",
    title: "NextStep",
    subtitle: "Job Application Tracking Platform",
    description: [
      "Developed a full-stack job tracking platform using Python, FastAPI, and TypeScript, streamlining job application management and tracking, resulting in a more efficient and organized job search experience.",
      "Designed and implemented scalable RESTful APIs to support real-time job tracking and dynamic updates, improving data retrieval efficiency and user experience.",
      "Built an intuitive frontend with TypeScript and ShadCN UI, integrating interactive search, filtering, and authentication, which enhanced usability and improved application navigation. Deployed on Vercel using Docker-based microservices for scalability.",
      "Created a Google Chrome extension to automate job tracking, enabling seamless data extraction from job listings and reducing manual entry, saving users significant time in their job application process.",
    ],
    technologies: [
      "React",
      "TypeScript",
      "Vite",
      "FastAPI",
      "Supabase",
      "Docker",
    ],
    category: "Project",
    href: "https://nextstep-app.vercel.app/",
  },
  {
    image: "images/DriveStats_MainPage.webp",
    title: "DriveStats",
    subtitle: "Vehicle Maintenance Tracking Platform",
    description: [
      "Built a full-stack car maintenance tracking platform with Python, FastAPI, React, and Docker, automating service history tracking, reminders, and analytics to optimize vehicle upkeep.",
      "Deployed and scaled AWS infrastructure using Amplify for the frontend, ECS with Docker for the backend, and RDS as the primary database, ensuring high availability and performance.",
      "Optimized container management by leveraging AWS ECR, ensuring seamless integration and deployment through ECS and efficient traffic distribution via a load balancer.",
      "Configured CI/CD pipelines to automate testing, building, and deployment processes.",
    ],
    technologies: ["Python", "TypeScript", "PostgreSQL", "Docker", "AWS"],
    category: "Project",
    github: "https://github.com/ivntsng/drive-stats",
  },
  {
    image: "images/novice_network_mainpage.webp",
    title: "NoviceNetwork",
    subtitle: "Bootcamp Graduate Community Platform",
    description: [
      "Connects aspiring and accomplished bootcamp graduates",
      "Enables experience sharing and networking",
      "Facilitates peer interactions across different learning stages",
    ],
    technologies: ["React", "Python", "PostgreSQL"],
    category: "Project",
    github: "https://github.com/ivntsng/novice-network",
  },
  {
    image: "images/AutoNexa_fp.webp",
    title: "AutoNexa",
    subtitle: "Automotive Management System",
    description: [
      "Comprehensive web application for car companies",
      "Manages salespeople and customer relationships",
      "Tracks automobile inventory",
      "Handles sales and service operations",
    ],
    technologies: ["React", "PostgreSQL", "Python", "Docker"],
    category: "Project",
    github: "https://github.com/ivntsng/AutoNexa",
  },
  {
    image: "images/zum_automation.svg",
    title: "Zum Automation",
    subtitle: "Process Automation Suite",
    description: [
      "Developed Python and Selenium automation scripts",
      "Updated driver dashboard data at scale",
      "Streamlined operational tasks",
      "Improved efficiency and data accuracy",
    ],
    technologies: ["Python", "Selenium"],
    category: "Automation",
  },
].map((item, index) => ({
  ...item,
  id: index + 1,
  style: {
    ...(item.style || {}),
    fontSize: "0.9rem",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    maxWidth: "100%",
    padding: "1rem",
  },
}));

export default Menu;
